import './polyfills.ts';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode, ChangeDetectorRef } from '@angular/core';
import { environment } from './environments/environment';
import { RootModule } from './root.module';
import { hmrBootstrap } from './hmr';
import { AppPreBootstrap } from './AppPreBootstrap';

import * as moment from 'moment';

import 'moment/min/locales.min';
import 'moment-timezone';

// in moment-format.pipe.ts we are forced to use moment(string) and for example
// '26 Jul 2018' is an unsupported format and moment displays warning that is forced
// to use moment(new Date(string)) and it's not safe and will not be supported in some
// next version, so uprgrade moment with caution
(moment as any)['suppressDeprecationWarnings'] = true;

// import * as toastr from 'toastr'; <-- using this makes following line not working..
toastr.options.positionClass = 'toast-top-center';

if (environment.production) {
    enableProdMode();
}

const bootstrap = () => {
    return platformBrowserDynamic().bootstrapModule(RootModule);
};

/* "Hot Module Replacement" is enabled as described on
 * https://medium.com/@beeman/tutorial-enable-hrm-in-angular-cli-apps-1b0d13b80130#.sa87zkloh
 */
const hotCheckBootstrap = () => {
    if (environment.hmr) {
        if (module['hot']) {
            hmrBootstrap(module, bootstrap); // HMR enabled bootstrap
        } else {
            console.error('HMR is not enabled for webpack-dev-server!');
            console.log('Are you using the --hmr flag for ng serve?');
        }
    } else {
        bootstrap(); // Regular bootstrap
    }
};

AppPreBootstrap.run(hotCheckBootstrap);
